<template>
  <div class="detail-list">
    <div class="detail-list__title">
      購買明細
    </div>

    <table class="table custom-table">
      <thead class="custom-table-title">
        <tr>
          <th scope="col">商品</th>
          <th scope="col">單價</th>
          <th scope="col">數量</th>
          <th scope="col">優惠</th>
          <th scope="col">價格</th>
          <th scope="col">刪除</th>
        </tr>
      </thead>
      <tbody class="custom-table-body">
        <slot></slot>
      </tbody>
    </table>
    <div class="detail-list__btns">
      <button v-if="modalType" @click="showAddBuyModal" class="transparent-btn">
        <span v-if="modalType === 'additionalPrice'">選擇加價購</span>
        <span v-if="modalType === 'freebies'">選擇贈品</span>
      </button>
    </div>

    <AddBuyModal ref="AddBuyModal" :modalType="modalType" />
  </div>
</template>

<script>
import AddBuyModal from '@/components/Modal/AddBuyModal';
import { mapState } from 'vuex';

export default {
  components: {
    AddBuyModal
  },
  data() {
    return {
      // 決定 modal 為 加價購(additionalPrice) 或 贈品(freebies)
      modalType: ''
    };
  },
  methods: {
    showAddBuyModal() {
      this.$refs.AddBuyModal.showModal();
    }
  },
  watch: {
    discount(val) {
      switch (val.type) {
        case 10:
          this.modalType = 'freebies';
          break;
        case 11:
          this.modalType = 'additionalPrice';
          break;
        default:
          break;
      }
    }
  },
  computed: {
    ...mapState('order', ['discount'])
  }
};
</script>
